import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { SOCIAL_EXTERNAL_PROVIDER } from '@constants';

// Helper function to convert uppercase to camelCase
const toCamelCase = (str) => str.charAt(0) + str.slice(1).toLowerCase();

// Generate initial state dynamically
const baseInitialState = {
    cpfValue: '',
};

const socialProviderState = Object.keys(SOCIAL_EXTERNAL_PROVIDER).reduce((acc, key) => {
    const formattedKey = `isRegisteredBy${toCamelCase(key)}`;
    acc[formattedKey] = false;
    return acc;
}, {});

const initialState = {
    ...baseInitialState,
    ...socialProviderState,
};

// Async thunk to fetch CPF
export const fetchMemberCPF = createAsyncThunk('user/fetchMemberCPF', async () => {
    try {
        const params = { bankCode: 'PIXCPF' };
        const memberBank = await window.SPL_Member.getMemberCPF(params);

        if (memberBank?.accountNumber) {
            return memberBank.accountNumber;
        } else {
            throw new Error('CPF value not found in the response');
        }
    } catch (err) {
        console.error('Failed to fetch member CPF:', err);
        throw err;
    }
});

// Async thunk to fetch social media provider
export const fetchMemberRegistrationSocialMediaProvider = createAsyncThunk('user/fetchMemberRegistrationSocialMediaProvider', async () => {
    try {
        const response = await window.SPL_Member.getRegistrationSocialMediaProvider();
        const socialProvider = response?.socialProvider;

        if (socialProvider && Object.values(SOCIAL_EXTERNAL_PROVIDER).includes(socialProvider)) {
            return socialProvider;
        } else {
            throw new Error('Invalid or missing social media provider');
        }
    } catch (err) {
        console.error('Failed to fetch member registration social media provider:', err);
        throw err;
    }
});

// Create Redux slice
const userSlice = createSlice({
    name: 'user',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchMemberCPF.fulfilled, (state, action) => {
            state.cpfValue = action?.payload;
        });

        builder.addCase(fetchMemberRegistrationSocialMediaProvider.fulfilled, (state, action) => {
            if (action.payload) {
                Object.keys(SOCIAL_EXTERNAL_PROVIDER).forEach((key) => {
                    const formattedKey = `isRegisteredBy${toCamelCase(key)}`;
                    state[formattedKey] = SOCIAL_EXTERNAL_PROVIDER[key] === action.payload;
                });
            }
        });
    },
});

export default userSlice.reducer;
